import { api } from "services"

export async function getRoles() {
  const { data } = await api.get("/permissions/roles")

  return data
}
